import { ITableColumnFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import DerivedColumnEdit, {
  DERIVED_COLUMN_EDIT_FORM_ANCHOR_ID,
} from './DerivedColumnEdit';
import React, { useEffect } from 'react';
import { IEditDerivedColumnModel } from '../DataModelerCdwTableGrid/types';
import DerivedColumnEditNew from './DerivedColumnEditNew';

interface IProps {
  viewKey: string;
  tableKey: string;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
  editDerivedColumnModel: IEditDerivedColumnModel;
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
}

const DerivedColumnDraft = ({
  viewKey,
  tableKey,
  availableColumnsFromServer,
  editDerivedColumnModel,
  collapsed,
  setCollapsed,
}: IProps) => {
  // scroll here if showing up to edit already mapped column
  useEffect(() => {
    if (editDerivedColumnModel.editedDerivedColumn) {
      const anchorEl = document.getElementById(
        DERIVED_COLUMN_EDIT_FORM_ANCHOR_ID,
      );
      if (anchorEl) {
        anchorEl.scrollIntoView();
      }
    }
  }, [editDerivedColumnModel.editedDerivedColumn]);

  if (editDerivedColumnModel.editedDerivedColumn) {
    const {
      editedDerivedColumn,
      updateEditedDerivedColumn,
      cancelEditedDerivedColumn,
      confirmEditedDerivedColumn,
    } = editDerivedColumnModel;
    return (
      <DerivedColumnEdit
        key={`edit-column-${tableKey}-${editedDerivedColumn?.columnName}`}
        viewKey={viewKey}
        tableKey={tableKey}
        availableColumnsFromServer={availableColumnsFromServer}
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        draftColumn={editedDerivedColumn}
        updateDraft={updateEditedDerivedColumn}
        cancel={cancelEditedDerivedColumn}
        confirm={confirmEditedDerivedColumn}
      />
    );
  }
  return (
    <DerivedColumnEditNew
      viewKey={viewKey}
      tableKey={tableKey}
      availableColumnsFromServer={availableColumnsFromServer}
      collapsed={collapsed}
      setCollapsed={setCollapsed}
    />
  );
};

export default DerivedColumnDraft;
